<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">Banner管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>banner类型：</label>
          <el-select v-model="modelType" placeholder="Select" style="width: 12em">
            <el-option v-for="item in modelTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editBannerDialog(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            border
        >
          <el-table-column type="index" label="序号" v-if="checkColList.indexOf('序号') > -1" width="54"></el-table-column>
          <el-table-column property="" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" width="150">
            <template #default="scope">
              <span style="flex: 1">{{scope.row.createTime}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="图片" v-if="checkColList.indexOf('图片') > -1" class-name="cursor" width="160">
            <template #default="scope">
              <div v-if="scope.row.img"><el-image style="height: 80px;min-width: 80px;" :src="scope.row.img"><template #error><div class="el-img-error">暂无图片</div></template></el-image></div>
              <p v-if="scope.row.bannerType == 2">广告banner</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="类型信息" v-if="checkColList.indexOf('类型信息') > -1">
            <template #default="scope">
              <p>位置：{{scope.row.modelType == 1 ? '发现' : scope.row.modelType == 2 ? '启动图' : '' }}</p>
              <p style="color:blue;">跳转：{{scope.row.type == 0 ? '不处理' : scope.row.type == 1 ? '内部浏览器' : scope.row.type == 2 ? '外部浏览器' : '未知'}}</p>
<!--              <p style="color:red;">平台：{{scope.row.platformType == 0 ? '客户端' : scope.row.platformType == 1 ? 'Android' : scope.row.platformType == 2 ? 'IOS' : scope.row.platformType == 3 ? 'Web' : '未知'}}</p>-->
            </template>
          </el-table-column>
          <el-table-column property="url" label="url" v-if="checkColList.indexOf('url') > -1"></el-table-column>
          <el-table-column property="shareUrl" label="分享url" v-if="checkColList.indexOf('分享url') > -1"></el-table-column>
          <el-table-column property="" label="分享图片" v-if="checkColList.indexOf('分享图片') > -1" class-name="cursor">
            <template #default="scope">
              <div v-if="scope.row.img2"><el-image style="height: 80px;min-width: 80px;" :src="scope.row.img2"><template #error><div class="el-img-error">暂无图片</div></template></el-image></div>
            </template>
          </el-table-column>
          <el-table-column property="title" label="标题" v-if="checkColList.indexOf('标题') > -1"></el-table-column>
          <el-table-column property="shareTitle" label="分享标题" v-if="checkColList.indexOf('分享标题') > -1"></el-table-column>
          <el-table-column property="descp" label="分享描述" v-if="checkColList.indexOf('分享描述') > -1"></el-table-column>
          <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1" width="54"></el-table-column>
          <el-table-column property="" label="展示地区" v-if="checkColList.indexOf('展示地区') > -1">
            <template #default="scope">
              <span>{{scope.row.province + scope.row.city}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1" width="70">
            <template #default="scope">
              <span>{{scope.row.state == 0 ? '待展示' : scope.row.state == 1 ? '展示中' : scope.row.state == 2 ? '已下架' : '未知'}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="70">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editBannerDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-show="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">上架</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-show="scope.row.state ==0 || scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">下架</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1"></el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getDiscoveryBannerPageList, updateDiscoveryBannerState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import discoveryBannerDialog from "./components/discoveryBannerDialog";
import ImgUpload from "./components/ImgUpload";

export default {
  name: "BannerDiscovery",
  components: { BtnGroup },
  data() {
    return {

      //状态
      stateArray: [
        {label: "全部",value: -1},
        {label: "展示中",value: 1},
        {label: "待展示",value: 0},
        {label: "已下架",value: 2},
        // {label: "已过期",value: 3}
      ],
      state: 1,

      //banner类型
      modelTypeArray: [
        {label: "全部",value: -1},
        {label: "发现列表",value: 1},
        {label: "启动图",value: 2}
      ],
      modelType: 1,

      //刷新组
      colList: ['序号', '创建时间', '图片', '类型信息', 'url', '分享url', '分享图片', '标题','分享标题','分享描述','排序', '展示地区', '状态', '操作', '备注'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.modelType = 1;
      this.state = 1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['modelType'] = this.modelType;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getDiscoveryBannerPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editBannerDialog(idx, row) {
      let _title = '';
      let bannerForm = {}
      if (idx > -1) {
        _title = '编辑banner'
        bannerForm = Object.assign({}, row);
      }else {
        _title = '创建banner'
      }
      Dialog.open({
        title: _title,
        component: discoveryBannerDialog,
        data: {
          bannerForm: bannerForm,
          ids: idx,
          width: '1060px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.label == '图片' && row.bannerType == 1) {
        Dialog.open({
          title: '上传banner图片',
          component: ImgUpload,
          data: {
            id: row.id,
            src: row.img,
            width: '400px',
            from: 3,
            imgType: 1
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '分享图片') {
        Dialog.open({
          title: '上传分享图片',
          component: ImgUpload,
          data: {
            id: row.id,
            src: row.img2,
            width: '400px',
            from: 3,
            imgType: 2
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

    },

    updateState(idx, row, state) {
      if(!this.pageDataList[idx]['img'] && state == 1 && row.bannerType == 1){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '图片未上传，不能上架',
          type: 'warning'
        });
        return false;
      }
      this.$confirm('确认把序号【' + (idx+1) + '】' + (state == 1?'上架':'下架') + '？').then(() => {
        this.pageDataList[idx]['updateLoading'] = true;
        let param = {};
        param['id'] = row.id;
        param['state'] = state;
        postFormData(updateDiscoveryBannerState, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['updateLoading'] = false;
        }).catch(()=> {
          this.pageDataList[idx]['updateLoading'] = false;
        })
      })
          .catch(() => {

          })

    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
